export default __webpack_public_path__ + "static/media/maayan-adam.b5a9a978.png";